module.exports = __webpack_public_path__ + "assets/icon_training_green.c0e19798.svg";